import styled from 'styled-components';

export const Container = styled.ul`
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 30px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 0;

  li {
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-self: center;
    cursor: pointer;
    transition: transform .5s;
  }

  li:hover {
    width: 30px;
    transform: scale(1.3);
  }
`;
